// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tailwind removed: all styles now use component-scoped CSS Modules or existing CSS files */

.unselectable-text {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari, Chrome, Opera */
  /* Konqueror HTML */
  /* Firefox */
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version */
}

.blue-scrollbar-vertical {
  &::-webkit-scrollbar {
    width: 3px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
    cursor: pointer;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #3e85f8;
    border-radius: 10px;
    cursor: pointer;
    -webkit-transition: background 0.3s ease-in-out;
    transition: background 0.3s ease-in-out;
    outline: 1px solid #fff;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #0a64f9;
    cursor: pointer !important;
  }
}

.blue-scrollbar-horizontal {
  &::-webkit-scrollbar {
    height: 3px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
    cursor: pointer;
  }
  
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #3e85f8;
    border-radius: 10px;
    cursor: pointer;
    -webkit-transition: background 0.3s ease-in-out;
    transition: background 0.3s ease-in-out;
    outline: 1px solid #fff;
  }
  
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #0a64f9;
    cursor: pointer !important;
  }
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,4FAA4F;;AAE5F;EACE,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAE1B,mBAAmB;EAEnB,YAAY;EAEZ,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA,UAAU;EACV;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;;EAEA,WAAW;EACX;IACE,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,+CAAuC;IAAvC,uCAAuC;IACvC,uBAAuB;EACzB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA,UAAU;EACV;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;;EAEA,WAAW;EACX;IACE,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,+CAAuC;IAAvC,uCAAuC;IACvC,uBAAuB;EACzB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;AACF","sourcesContent":["/* Tailwind removed: all styles now use component-scoped CSS Modules or existing CSS files */\n\n.unselectable-text {\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari, Chrome, Opera */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version */\n}\n\n.blue-scrollbar-vertical {\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px grey;\n    border-radius: 10px;\n    cursor: pointer;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: #3e85f8;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.3s ease-in-out;\n    outline: 1px solid #fff;\n  }\n\n  /* Handle on hover */\n  &::-webkit-scrollbar-thumb:hover {\n    background: #0a64f9;\n    cursor: pointer !important;\n  }\n}\n\n.blue-scrollbar-horizontal {\n  &::-webkit-scrollbar {\n    height: 3px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px grey;\n    border-radius: 10px;\n    cursor: pointer;\n  }\n  \n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: #3e85f8;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.3s ease-in-out;\n    outline: 1px solid #fff;\n  }\n  \n  /* Handle on hover */\n  &::-webkit-scrollbar-thumb:hover {\n    background: #0a64f9;\n    cursor: pointer !important;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
